import {AdvertisementFormField} from "../types/advertisement-initial-statistics-modal.types";

export const advertisementInitialStatisticsFormFields: Array<AdvertisementFormField> = [
  {
    fieldName: '',
    label: 'Файлы',
    type: 'button',
    rowKey: 'fileAndPrice'
  },
  {
    fieldName: 'advertisementPrice',
    label: 'Цена',
    type: 'number',
    rowKey: 'fileAndPrice',
    inputType: 'number',
    needMatTextSuffix: true,
    matTextSuffixValue: '₽',
    needMaximumFractionDigits: true,
    useLimits: false,
    isDecimalPoint: true
  },
  {
    fieldName: 'targetAudienceQuality',
    label: 'ЦА соответствует',
    type: 'select',
    rowKey: 'fraction'
  },
  {
    fieldName: 'targetAudience',
    label: '',
    type: 'toggleGroup',
    rowKey: 'fraction'
  },
  {
    fieldName: 'bloggerBelief',
    label: 'Блогер "продающий" ЦА верит?',
    type: 'select',
    rowKey: 'bloggerBelief'
  },
  {
    fieldName: 'audiencePercent',
    label: 'Процент аудитории Ж / М',
    type: 'number',
    inputType: 'number',
    rowKey: 'audience',
    needMatTextSuffix: true,
    matTextSuffixValue: '%',
    needMaximumFractionDigits: true,
    placeholder: 'Доля',
    isDecimalPoint: true
  },
  {
    fieldName: 'audienceType',
    label: '',
    type: 'toggleGroup',
    rowKey: 'audience'
  },
  {
    fieldName: 'viewsBoosting',
    label: 'Есть накрутки?',
    type: 'select',
    rowKey: 'viewsBoostingAndRoscom'
  },
  {
    fieldName: 'roscomRegistrationStatus',
    label: 'Рег. Роскомнадзор',
    type: 'select',
    rowKey: 'viewsBoostingAndRoscom'
  },
  {
    fieldName: 'region',
    label: 'Наш регион',
    type: 'select',
    rowKey: 'region'
  },
  {
    fieldName: 'regionPercent',
    label: 'Доля',
    type: 'number',
    inputType: 'number',
    rowKey: 'region',
    needMatTextSuffix: true,
    matTextSuffixValue: '%',
    needMaximumFractionDigits: true,
    isDecimalPoint: true
  },
  {
    fieldName: 'engagementRate',
    label: 'Средний ER',
    type: 'number',
    inputType: 'number',
    rowKey: 'engagementRate',
    needMatTextSuffix: true,
    matTextSuffixValue: '%',
    placeholder: 'Доля',
    needMaximumFractionDigits: true,
    isDecimalPoint: true
  },
  {
    fieldName: 'guaranteedCoverage',
    label: 'Гарант',
    type: 'number',
    inputType: 'number',
    rowKey: 'coverage',
    useLimits: false,
    isDecimalPoint: false
  },
  {
    fieldName: 'coveragePlanned',
    label: 'Охват заявлен',
    type: 'number',
    inputType: 'number',
    rowKey: 'coverage',
    useLimits: false,
    isDecimalPoint: false
  },
  {
    fieldName: 'kas',
    label: 'КАС',
    type: 'number',
    inputType: 'number',
    rowKey: 'kasAndKyr',
    needMatTextSuffix: true,
    needMaximumFractionDigits: true,
    matTextSuffixValue: '%',
    noEdit: true
  },
  {
    fieldName: 'kyr',
    label: 'КУР',
    type: 'number',
    inputType: 'number',
    rowKey: 'kasAndKyr',
    needMatTextSuffix: true,
    needMaximumFractionDigits: true,
    matTextSuffixValue: '%',
    noEdit: true
  },
  {
    fieldName: 'link',
    label: 'Ссылка',
    type: 'text',
    rowKey: 'link',
    inputType: 'text'
  }
]
